import { FILES_PER_DROP_LIMIT } from 'modules/documents/common/documents.consts'
import type { FileErrorTypeName } from 'modules/documents/common/documents.types'
import { analyticsTracker } from 'utils'

export const dispatchAddFilesEvent = (eventType: 'drop' | 'click', files: File[]) => {
  const { FIL_CLICK_ADD_FILES, FIL_DROP_FILES } = analyticsTracker.eventNames

  const EVENTS = {
    drop: FIL_DROP_FILES,
    click: FIL_CLICK_ADD_FILES,
  }

  const event = EVENTS[eventType]

  analyticsTracker.eventTrack(event, {
    files: files.map(file => ({ name: file.name, type: file.type, size: file.size })),
  })
}

export const dispatchRemoveFileEvent = (idFile: string) => {
  const { FIL_CLICK_REMOVE_FILE } = analyticsTracker.eventNames

  analyticsTracker.eventTrack(FIL_CLICK_REMOVE_FILE, {
    file: idFile,
  })
}

export const dispatchErrorEvent = (errorType: FileErrorTypeName) => {
  const { FIL_UPLOAD_ERROR } = analyticsTracker.eventNames

  const ERROR_MAP = {
    file_extension_not_supported: 'File type not supported.',
    max_files_exceeded: `You can add up to ${FILES_PER_DROP_LIMIT} files at a time.`,
  }

  const error = ERROR_MAP[errorType]

  analyticsTracker.eventTrack(FIL_UPLOAD_ERROR, {
    error,
  })
}
